'use strict';

angular.module('mean.bids').controller('BidBuilderReviewController', ['$scope', 'MeanUser', 'Global', 'Bids', '$filter', '$sce', 'toaster', 'NotifyService', 'BidBuilderReview', 'CompanyFactors', '$location', 'tradeCodeService', 'taskTotalsService',
  function($scope, MeanUser, Global, Bids, $filter, $sce, toaster, NotifyService, BidBuilderReview, CompanyFactors, $location, tradeCodeService, taskTotalsService) {
    $scope.global = Global;

    $scope.expanded_table = 'true';
    $scope.bid_total_labor = 0;
    $scope.bid_total_materials = 0;
    $scope.bid_total_equipment = 0;
    $scope.bid_total = 0;
    $scope.bid_general_liability = 0;
    $scope.trade_totals = [];
    $scope.current_trade_selection = {}
    $scope.current_trade_selection.trade = 'Total';
    $scope.bid_tasks = [];

    $scope.materials = [];
    $scope.equipment = [];

    $scope.MaterialTotal = 0;
    $scope.EquipmentTotal = 0;

    $scope.sortType = ['trade', 'note', 'name', 'plan_code', 'task_code'];
    $scope.sortReverse = false;
    $scope.filtered_menu_items = ['Specs', 'Materials', 'Total Materials'];

    var data = [];

    $scope.toggleTableColumns = function() {
        if($scope.expanded_table === 'true') {
            $scope.expanded_table = 'false';
        } else {
            $scope.expanded_table = 'true';
        }
    };

    $scope.filteredMenuItem = function(item) {
        return ($scope.filtered_menu_items.indexOf(item) !== -1);
    };

    $scope.init = function() {
        $scope.expanded_table = 'false';
    	$scope.bid = BidBuilderReview.get();

        if(!$scope.bid || !$scope.bid._id){
            $location.path('/');
            return;
        }

        $scope.specs = [];

        $scope.bidding_trades = [];
        $scope.bidding_trades.push('Total');
        $scope.bid.bidding_trades.forEach(function(bid) {
            $scope.bidding_trades.push(bid.trade);
            $scope.specs.push({
                trade: bid.trade,
                inclusions: bid.inclusions,
                exclusions: bid.exclusions
            });
        });
        //add a specs page
        //$scope.bidding_trades.push('Specs');
        $scope.bidding_trades.push('Total Materials');
        $scope.bidding_trades.push('Total Equipment');

    	$scope.bid_menu = [];

    	var menu = $scope.bid.project_plan;

        _.each($scope.bid.plan_codes, function(plan_code) {
            $scope.bid_menu.push({
                item: plan_code.code
            });
        });

        $scope.trade_totals = [];
        $scope.bid_menu.push({
            item: 'Specs'
        });
        $scope.bid_menu.push({
            item: 'Materials'
        });
        $scope.bid_menu.push({
            item: 'Total Materials'
        });

        $scope.current_plan = $scope.bid_menu[0];
        
        CompanyFactors.query({}, function(company_factors) {
            $scope.all_company_factors = company_factors;

            //$scope.trade_totals = [];

            $scope.bid.bidding_trades.forEach(function(bid, idx) {
                var current_bid_trade = bid.trade;
                $scope.trade_totals.push({
                    trade: bid.trade
                });
                //$scope.trade_totals[idx].plan_totals = [];

                $scope.my_bid_trade = $scope.getTradeCode(current_bid_trade);
                $scope.bid_menu.forEach(function(menu, mdx) {
                    if(menu.item === 'Specs') return;
                    if(menu.item === 'Materials') return;
                    if(menu.item === 'Total Materials') return;

                    var bid_tasks = [];
                	$scope.bid.task_list.forEach(function(task, index){
                		if( task.trade === $scope.my_bid_trade){
                            //task.plan_code = menu.item;

                            //need to get bid_hours, quantities, etc... for each bid menu
                            //make sure the plan and task id's match up.
                            bid.bid.forEach(function(current_bid, ii) {
                                if(current_bid.plan_code === menu.item) {
                                    if(current_bid.task_id === task._id) {
                                        current_bid.equipment.forEach(function(eq, eidx) {
                                            task.equipment.forEach(function(teq, teidx) {
                                                if(eq.equipment_id === teq._id) {
                                                    teq.quantity = eq.quantity;
                                                    if(eq.price_per_order)
                                                      teq.price_per_order = eq.price_per_order;
                                                    if(eq.delivery_price)
                                                      teq.delivery_price = eq.delivery_price;
                                                }
                                            });
                                        });

                                        current_bid.materials.forEach(function(mq, midx) {
                                            task.materials.forEach(function(tmq, tmidx) {
                                                if(mq.material_id === tmq._id) {
                                                    tmq.quantity = mq.quantity;
                                                    if(mq.price_per_order)
                                                      tmq.price_per_order = mq.price_per_order;
                                                    if(mq.delivery_price)
                                                      tmq.delivery_price = mq.delivery_price;
                                                }
                                            });
                                        });
                                        
                                        current_bid.subtasks.forEach(function(subtask, si) {
                                            task.subtasks.forEach(function(tsub, tsi) {
                                                if(subtask.task_id === tsub._id) {
                                                    tsub.quantity = subtask.quantity;
                                                    tsub.bid_hours = subtask.bid_hours;
                                                    tsub.labor = subtask.labor;
                                                }
                                            });
                                        });
                                    }
                                } else {
                                    //this bid does not match the current plan but it matches the task.
                                    //we need to see if there is a plan/bid for this task.
                                    //if there is we need to leave it alone, if there is not
                                    //then we should clear it out.
                                    var bid_found = false;
                                    for(var i=0; i<bid.bid.length; i=i+1){
                                        if(bid.bid[i].task_id === task._id &&
                                            bid.bid[i].plan_code === menu.item)
                                          bid_found = true;
                                    }

                                    if(!bid_found){
                                        task.equipment.forEach(function(mat){
                                            mat.quantity = '';
                                        });
                                        task.materials.forEach(function(eq) {
                                            eq.quantity = '';
                                        });
                                        task.subtasks.forEach(function(sub) {
                                            sub.quantity = '';
                                            sub.bid_hours = '';
                                        });
                                    }
                                }
                            });
                			
                            bid_tasks.push(task);
                		}
                	});
                    $scope.applayCalculations(bid_tasks, current_bid_trade);

                    if(!$scope.trade_totals[idx].plan_totals)
                      $scope.trade_totals[idx].plan_totals = [];

                    $scope.trade_totals[idx].plan_totals.push(bid_tasks);
                    $scope.trade_totals[idx].plan_totals[mdx].plan_code = menu.item;

                    bid_tasks.forEach(function(bid) {
                        bid.materials.forEach(function(mat) {
                            $scope.materials.push(angular.copy(mat));
                            $scope.materials[$scope.materials.length-1].plan_code = menu.item;
                            $scope.materials[$scope.materials.length-1].task_code = bid.trade + bid.task;
                            $scope.MaterialTotal += Number(mat.price_per_order) * Number(mat.quantity);
                        });

                        bid.equipment.forEach(function(eq) {
                            $scope.equipment.push(angular.copy(eq));
                            $scope.equipment[$scope.equipment.length-1].plan_code = menu.item;
                            $scope.equipment[$scope.equipment.length-1].task_code = bid.trade + bid.task;
                            $scope.EquipmentTotal += Number(eq.price_per_order) * Number(eq.quantity);
                        });
                    });
                });

                //$scope.applayCalculations(bid_tasks, current_bid_trade);
                //$scope.task_totals.push(bid_tasks);
            });

            $scope.calculateTotals($scope.trade_totals);
	    });
    };

    $scope.materialsPage = function(trade) {
        var bid_tasks = [];

        if(!$scope.bid || !$scope.bid._id){
            return;
        }

        bid_tasks = $filter('filter')($scope.bid.task_list, { 
            trade: $scope.getTradeCode(trade)}, true);
    };

    $scope.totals = [];

    $scope.calculateTotals = function(trades) {
        //step through each trade
        trades.forEach(function(trade, index) {
            var plan_total = 0;
            trade.plan_totals.forEach(function(plan, idx) {
                plan_total = plan_total + plan.bid_total;
                $scope.totals.push({
                    trade: trade.trade,
                    plan: plan.plan_code,
                    total: plan.bid_total
                });
            });
            trade.plan_total = plan_total;
        });
    };

    $scope.getPlanTotals = function(item) {
        var temp = $filter('filter')($scope.totals, {plan: item}, true);
        var ret_val = 0;
        temp.forEach(function(it) {
            ret_val = ret_val + it.total;
        });
        return ret_val;
    };

    $scope.getTradeTotals = function(item) {
        var temp = $filter('filter')($scope.totals, {trade: item}, true);
        var ret_val = 0;
        temp.forEach(function(it) {
            ret_val = ret_val + it.total;
        });
        return ret_val;
    };

    $scope.getAllTotals = function() {
        var ret_val = 0;
        $scope.totals.forEach(function(it) {
            ret_val = ret_val + it.total;
        });
        return ret_val;
    };

    $scope.updateTablePlan = function() {
        $scope.bid_tasks = [];
        var current_bid_trade = [];

        var bid_trade = $filter('filter')($scope.bid.bidding_trades, { 'trade': $scope.current_trade_selection.trade}, true);

        if(bid_trade.length !== 1) {
            alert('There was a problem getting the trades bid list.  Contact Admin.');
            return;
        }

        var bid_trade = $scope.bid.bidding_trades[0];

        var trade_code = $scope.getTradeCode($scope.current_trade_selection.trade);
        if(!trade_code) return;
        
        var bids = $filter('filter')(bid_trade[0].bid, {'plan_code': $scope.current_plan.item}, true);
        var task_list = $filter('filter')($scope.bid.task_list, { 'trade': trade_code}, true);

        //first build a task_list that only has the current bid trade
        bids.forEach(function(bid_task) {
            var task = $filter('filter')(task_list, {_id: bid_task.task_id}, true);

            if(task.length !== 1) {
                console.log('There is more than one task with the task id requested ' + bid_task.task_id);
                return;
            }

            task[0].plan_code = bid_task.plan_code;

            bid_task.equipment.forEach(function(eq, eidx) {
                task[0].equipment.forEach(function(teq, teidx) {
                    if(eq.equipment_id === teq._id) {
                        teq.quantity = eq.quantity;
                        if(eq.price_per_order)
                          teq.price_per_order = eq.price_per_order;
                        if(eq.delivery_price)
                          teq.delivery_price = eq.delivery_price;
                    }
                });
            });
            bid_task.materials.forEach(function(mq, midx) {
                task[0].materials.forEach(function(tmq, tmidx) {
                    if(mq.material_id === tmq._id && tmq._id) {
                        tmq.quantity = mq.quantity;
                        if(mq.price_per_order)
                          tmq.price_per_order = mq.price_per_order;
                        if(mq.delivery_price)
                          tmq.delivery_price = mq.delivery_price;
                    }
                });
            });
            bid_task.subtasks.forEach(function(subtask, si) {
                task[0].subtasks.forEach(function(tsub, tsi) {
                    if(subtask.task_id === tsub._id) {
                        tsub.quantity = subtask.quantity;
                        tsub.bid_hours = subtask.bid_hours;
                        tsub.labor = subtask.labor;
                    }
                });
            });

            $scope.bid_tasks.push(task[0]);
        });

        $scope.applayCalculations($scope.bid_tasks, $scope.current_trade_selection.trade);
    };

    $scope.onSelect = function(item) {
        console.log('in on select ' + item + $scope);
        var trade_bid = $filter('filter')($scope.trade_totals, {trade: item}, true);

        if(trade_bid.length === 0) {
            // if(item === 'Specs') {
            //     $scope.current_trade_selection = {};
            //     $scope.current_trade_selection.trade = 'Specs';
            //     return;
            // }

            if(item === 'Total Materials') {
                $scope.current_trade_selection = {};
                $scope.current_trade_selection.trade = 'Total Materials';
                return;
            }

            if(item === 'Total Equipment') {
                $scope.current_trade_selection = {};
                $scope.current_trade_selection.trade = 'Total Equipment';
                return;
            }

            if(item !== 'Total') {
                alert('there was an issue getting the totals for ' + item);
                return;
            }

            $scope.current_trade_selection = {};
            $scope.current_trade_selection.trade = 'Total';

        }

        //$scope.current_plan = $scope.bid_menu[0];

        if(trade_bid.length === 1) {
            $scope.current_trade_selection = trade_bid[0];
            $scope.updateTablePlan();
        } else if(item !== 'Total')
          alert('problem with trade bid selection ' + item);
    };

    $scope.onPlanSelect = function(item) {
        console.log('in the onSelect function ' + item.item);
        $scope.current_plan = item;
        // if($scope.current_plan.item === 'Cover') {
        //     data = [];
        //     $scope.buildBidCoverPage();
        // } else if($scope.current_plan.item === 'Materials') {
        //     data = [];
        // } else if($scope.current_plan.item === 'Equipment') {
        //     data = [];
        // } else if($scope.current_plan.item === 'Specs') {
        //     data = [];
        // } else {
            $scope.updateTablePlan();
        //}
    };
    
    $scope.viewBidBuilderDetails = function(index) {
        $location.path('builder/details');
    };

    $scope.applayCalculations = function(tasks, trade) {

        var company_factors = $filter('filter')($scope.all_company_factors, { trade_code: $scope.getTradeCode(trade) });

        if(company_factors.length !== 1) {
            alert('Problem getting company factors for ' + trade);
            return;
        }

        taskTotalsService.getTradeCalculations(tasks, trade, company_factors[0]);

        $scope.bid_total = tasks.bid_total;
        $scope.bid_general_liability = tasks.bid_total_labor * company_factors[0].general_liability;
        $scope.bid_general_liability += tasks.bid_total_materials * company_factors[0].general_liability;
        $scope.bid_general_liability += tasks.bid_total_equipment * company_factors[0].general_liability;
        $scope.bid_total_labor = tasks.bid_total_labor;
        $scope.bid_total_materials = tasks.bid_total_materials;
        $scope.bid_total_equipment = tasks.bid_total_equipment;
        $scope.bid_direct_labor = tasks.bid_direct_labor;
        $scope.bid_workers_comp = tasks.bid_workers_comp;
        $scope.bid_payroll_taxes = tasks.bid_payroll_taxes;
        $scope.bid_overhead_and_profit = tasks.bid_overhead_and_profit;
        $scope.bid_total_hours_allowed = tasks.bid_total_hours_allowed;
    };

    $scope.getTradeCode = function(trade) {
        return tradeCodeService.getCode(trade);
    };

    $scope.getTradeString = function(trade) {
        return tradeCodeService.getName(trade);
    };
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/bids/public/controllers/bidbuilderreview.js